<!--
 * @Copyright: 12308
 * @Author: xuxinxiang
 * @Date: 2020-04-14 08:59:27
 * @LastEditTime: 2020-04-26 16:23:32
 * @Description: 
 -->

<template>
    <div class="list-page">
        <ul id="tool">
            <!-- <li
                v-for="content in $route.meta.list"
                :key="content.id"
                @click="$router.push(`${$route.path}/${content.id}`)"
            >
                {{ content.title }}
            </li> -->
            <li
                v-for="content in contents"
                :key="content.id"
                @click="$router.push(`${$route.path}/${content.id}`)"
            >
                {{ content.title }}
            </li>
        </ul>
    </div>
</template>

<script>
import { getList } from "../../../api/gm/api-content";
export default {
    data() {
        return {
            name: "工具",
            contents: [],
            viewContentSearch: {
                productid: this.$route.meta.pid,
                relationid: this.$route.meta.rid,
                relationmodel: "list",
                isdelete: false
            }
        };
        // return {
        // };
    },
    created() {
        this.getData();
        // console.log(this.$route.meta.pid);
        // console.log(this.$route.meta.rid);
        if (document.body.clientWidth < 1024) {
          //document .getElementById("leftMenu").setAttribute("class", "show");
        }
    },
    watch: {
        $route: {
            handler: function() {
                (this.viewContentSearch.productid = this.$route.meta.pid),
                    (this.viewContentSearch.relationid = this.$route.meta.rid),
                    this.getData();
            }
        }
    },
    methods: {
        getData() {
            getList(this.viewContentSearch).then(res => {
                if (res.code === 0) {
                    this.contents = res.data;
                } else {
                    console.log(res.msg);
                }
            });
        }
    }
};
</script>
<style lang="less" scoped>
.list-page {
    ul {
        padding: 0;
        li {
            padding: 0px 30px;
            height: 55px;
            line-height: 53px;
            background: #e0e9fc;
            list-style: none;
            border: 1px solid #e0e9fc;
            cursor: pointer;
            &:hover {
                border: 1px solid #6b8ac0;
                background: #dbe5fb;
                color: #214d98;
            }
        }
    }
}

@media (max-width: 1024px) {
    .list-page {
        ul {
            li {
                padding: 0px 10px;
                height: 35px;
                line-height: 33px;
                font-size: 14px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/front/components/list-page.vue